"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var scriptLoader_1 = require("../../utils/scriptLoader/scriptLoader");
var Recaptcha = React.memo(function (props) {
    React.useEffect(function () {
        loadCaptcha(); // TODO potential improvement: might need to fix race condition - script loaded vs dom rendered
    }, []);
    var sitekey = props.sitekey, theme = props.theme, size = props.size, tabindex = props.tabindex, lang = props.lang, onSuccess = props.onSuccess, onExpire = props.onExpire, onError = props.onError;
    var elementId = "recaptcha-" + Math.ceil(Math.random() * 1000);
    var widgetId;
    var loadCaptcha = function () {
        if (window.grecaptcha) {
            onloadCaptcha();
            return;
        }
        window.onloadCallback = onloadCaptcha;
        scriptLoader_1.ScriptLoader.loadScript({
            src: "https://www.google.com/recaptcha/api.js?render=explicit&onload=onloadCallback&hl=" + lang,
            id: 'recaptcha-script',
            async: true,
            defer: true
        });
    };
    var onloadCaptcha = function () {
        widgetId = window.grecaptcha.render(elementId, {
            sitekey: sitekey,
            theme: theme,
            size: size,
            tabindex: tabindex,
            callback: function (token) {
                onSuccess(token);
            },
            'expired-callback': function (response) {
                resetCaptcha();
                if (onExpire) {
                    onExpire(response);
                }
            },
            'error-callback': function (response) {
                if (onError) {
                    onError(response);
                }
            },
        });
    };
    var resetCaptcha = function () {
        if (window.grecaptcha && widgetId) {
            window.grecaptcha.reset(widgetId);
        }
    };
    return React.createElement("div", { id: elementId });
});
Recaptcha.displayName = 'Recaptcha';
exports.default = Recaptcha;
//# sourceMappingURL=Recaptcha.js.map